import { render, staticRenderFns } from "./CargaRefrendoAlcoholes.vue?vue&type=template&id=2ef7c0ba&"
import script from "./CargaRefrendoAlcoholes.vue?vue&type=script&lang=js&"
export * from "./CargaRefrendoAlcoholes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports